import React from 'react';
import {
  StyledSplitModalWrapper,
  StyledSplitModalCol,
  StyledModalImage,
  StyledInfoContainer,
  StyledModalTitle,
  StyledContentTitle,
  StyledContentContainer,
  StyledButton,
} from './styled.js';

const ContentSplitModal = ({ onClick, modalTitle, title, content, image, imagePosition, imageSize, btnText }) => (
  <StyledSplitModalWrapper>
    <StyledSplitModalCol>
      <StyledInfoContainer>
        <StyledModalTitle>{modalTitle}</StyledModalTitle>
        <StyledContentTitle>{title}</StyledContentTitle>
        <StyledContentContainer>
          {content}
        </StyledContentContainer>
        <StyledButton onClick={onClick}>{btnText}</StyledButton>
      </StyledInfoContainer>
    </StyledSplitModalCol>
    <StyledSplitModalCol>
      <StyledModalImage imgUrl={image} imagePosition={imagePosition} imageSize={imageSize} />
    </StyledSplitModalCol>
  </StyledSplitModalWrapper>
);

export default ContentSplitModal;
